export default "__VITE_ASSET__DJJ64erS__"